import React from "react";
import "./Grievance.css";

const Grievance = () => {
    return (
        <div className="grievance-page-container">
            <h1 className="grievance-heading">Grievance Redressal Process</h1>
            <p className="grievance-description">
                At <b>United Investment Point</b>, we are committed to providing exceptional services to our clients. We understand that at times, issues may arise, and we are here to resolve them swiftly and fairly. Your grievances help us improve our processes. We aim to respond to your complaints efficiently, courteously, and with fairness.
            </p>

            {/* Step 1: Contact Us */}
            <div className="grievance-step">
                <h2 className="grievance-heading-numbered">
                    1. Contact Via Email
                </h2>
                <p>
                    If you have any grievances or complaints, please feel free to reach out to us via email. We take all complaints seriously and will respond to you promptly.
                </p>
                <ul>
                    <li>Mr. Manjul Awasthi</li>
                    <li>Email: <a href="mailto:awasthi.manjul@gmail.com" className="grievance-link">awasthi.manjul@gmail.com</a></li>
                </ul>
                <p>
                    Please provide a clear description of your grievance, including any relevant details or documentation, so we can resolve the issue as quickly as possible.
                </p>
            </div>

            {/* Step 2: Contact Us via Phone */}
            <div className="grievance-step">
                <h2 className="grievance-heading-numbered">
                    2. Call Us
                </h2>
                <p>
                    If you prefer to speak directly to someone, you can reach out to us via phone. We are here to assist you and address any concerns you may have.
                </p>
                <ul>
                    <li>Mr. Manjul Awasthi</li>
                    <li>Reach us at: <a href="tel:+919415762826" className="grievance-link">+91 9415762826</a></li>
                </ul>
                <p>
                    Please call during our business hours, and we will do our best to resolve the issue or direct you to the appropriate department for further assistance.
                </p>
            </div>

            {/* Footer Message */}
            <div className="grievance-footer">
                <p>
                    The response may take 1-2 business days, and we will do our best to resolve the issue as promptly as possible.
                </p>
            </div>
        </div>
    );
};

export default Grievance;
